import { render, staticRenderFns } from "./ItemField.vue?vue&type=template&id=199dde3d&scoped=true&"
import script from "./ItemField.vue?vue&type=script&lang=js&"
export * from "./ItemField.vue?vue&type=script&lang=js&"
import style0 from "./ItemField.vue?vue&type=style&index=0&id=199dde3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199dde3d",
  null
  
)

export default component.exports